import C from "@/modules/user/UserAvatar.module.css";

import { cn } from "@/utils/classNames.ts";
import type { User } from "@warrenio/api-spec/spec.oats.gen";

export function NameAvatar({ name, size = C.HeaderSize }: { name: string; size?: string }) {
    return <div className={cn(C.Avatar, size)}>{name.slice(0, 2)}</div>;
}

export function UserAvatar({ user, inHeader }: { user: User; inHeader?: boolean }) {
    const {
        name,
        profile_data: { avatar },
    } = user;

    return (
        <div className={cn(C.Avatar, inHeader ? C.HeaderSize : C.UserSize)}>
            {avatar ? <img fetchPriority="low" src={avatar} alt={name} /> : name.slice(0, 2)}
        </div>
    );
}
